module.exports = __webpack_public_path__ + "img/payumoney.3045d0d5.png";